import React, { SyntheticEvent, useCallback, useState } from "react";
import { Loader } from "lucide-react";

interface PostVideoProcessingPlaceholderProps {
    thumbnail?: string;
    aspectRatio?: number;
    className?: string;
}

const PostVideoProcessingPlaceholder: React.FC<PostVideoProcessingPlaceholderProps> = ({
    thumbnail,
    aspectRatio: providedAspectRatio,
    className,
}) => {
    const [aspectRatio, setAspectRatio] = useState<number | null>(
        providedAspectRatio ?? null,
    );

    const handleImageLoad = useCallback((e: SyntheticEvent<HTMLImageElement>) => {
        const img = e.currentTarget;
        if (img.naturalWidth > 0 && img.naturalHeight > 0) {
            setAspectRatio(img.naturalWidth / img.naturalHeight);
        }
    }, []);

    const isPortrait = aspectRatio !== null && aspectRatio < 1;

    return (
        <div
            className={`bg-black overflow-hidden relative mx-auto ${className ?? ""}`}
            style={{
                aspectRatio: aspectRatio ?? 16 / 9,
                width: isPortrait ? "auto" : "100%",
                maxHeight: isPortrait ? 500 : undefined,
                maxWidth: "100%",
            }}
        >
            {thumbnail ? (
                <img
                    src={thumbnail}
                    alt="Media"
                    onLoad={handleImageLoad}
                    className="w-full h-full object-contain"
                />
            ) : (
                <div className="w-full h-full bg-black" />
            )}
            <div className="absolute inset-0 bg-black/60 flex items-center justify-center rounded">
                <span className="text-white text-sm font-medium">Video Processing</span>
                <Loader className="ml-2 animate-spin text-secondary" />
            </div>
        </div>
    );
};

export default PostVideoProcessingPlaceholder;
